<template>
  <div>
    <breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商解冻审批'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">

                <div class="h-pieceCon2" style="padding:0">
                  <div class="h-formLine">
                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                      <h1>申诉信息</h1>
                    </div>
                    <el-form :inline="true" :model="appealData"  :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1 appeal"
                             style="margin-top: 0.4rem">
                      <el-form-item label="申诉方" class="h-elformWrap-2 table-1" prop="username">
                        <el-input :clearable="true"  v-model="appealData.username" disabled></el-input>
                      </el-form-item>
                      <el-form-item label="渠道" class="h-elformWrap-2 table-1" prop="channelAppeal">
                        <brselect clearable category="sales_region"
                                  :v="appealData.channelAppeal"
                                  v-model="appealData.channelAppeal"></brselect>
                      </el-form-item>
                      <el-form-item label="窜货方" class="h-elformWrap-2 table-1" prop="customername">
                        <el-select v-model="appealData.customername" filterable  :filter-method="showComList" clearable
                                   @change="showComList1($event)"
                                   placeholder="请输入"
                                   :remote-method="showComList" >
                          <el-option v-for="(item) in agentList"
                                     :key="item.index"
                                     :label="item.customerName1"
                                     :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="用户单位" class="h-elformWrap-2 table-1" prop="userUnit">
                        <el-select v-model="appealData.userUnit" remote filterable :filter-method="showGroupList" :clearable="true"
                                   placeholder="请输入"
                                   :remote-method="showGroupList" @change="showGroupList">
                          <el-option v-for="(item,index) in customerNameList"
                                     :key="index"
                                     :label="item.deptName"
                                     :value="item.deptName">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <br>
                      <el-form-item label="型号及数量" class="h-elformWrap-2" prop="modelAndNum">
                        <el-input :clearable="true"  v-model="appealData.modelAndNum" ></el-input>
                      </el-form-item>
                      <el-form-item label="申诉事件" class="h-elformWrap-1" prop="appealContent">
                        <el-input :clearable="true" style="width: 95%;padding-left: 20px;" :rows="5" type="textarea" v-model="appealData.appealContent"   placeholder="请输入内容"></el-input>
                      </el-form-item>

                      <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                        <h1>申诉资料</h1>
                      </div>

                      <el-form-item label="" class="h-elformWrap-2 table-1">
                        <div style="margin-left: 80px;color: #4a4a4a"> 1.[申诉方用户管理] 被窜用户的归属信息</div>
                      </el-form-item>
                      <el-form-item class="h-elformWrap-2" prop="file1">
                        <div style="margin-top: -5px">
                          <brupload
                              :refid="refid"
                              reftype="窜货申诉-归属信息"
                              uploadflag
                              delflag
                              :showtime="false"
                              :tpFlag = 'true'
                          >
                          </brupload>
                        </div>
                      </el-form-item>

                      <el-form-item label="" class="h-elformWrap-2 table-1">
                        <div style="margin-left: 80px;color: #4a4a4a"> 2.[申诉方漏斗信息] 被窜用户的交互信息或漏斗信息</div>
                      </el-form-item>
                      <el-form-item class="h-elformWrap-2" prop="file2">
                        <div style="margin-top: -5px">
                          <brupload
                              :refid="refid"
                              reftype="窜货申诉-漏斗信息"
                              uploadflag
                              delflag
                              :showtime="false"
                              :tpFlag = 'true'
                          >
                          </brupload>
                        </div>
                      </el-form-item>

                      <el-form-item label="" class="h-elformWrap-2 table-1">
                        <div style="margin-left: 80px;color: #4a4a4a"> 3.[窜货用户] 带有条码的产品及安装所在用户地点</div>
                      </el-form-item>
                      <el-form-item class="h-elformWrap-2" prop="file3">
                        <div style="margin-top: -5px">
                          <brupload
                              :refid="refid"
                              reftype="窜货申诉-用户地点"
                              uploadflag
                              delflag
                              :showtime="false"
                              :tpFlag = 'true'
                          >
                          </brupload>
                        </div>
                      </el-form-item>

                      <el-form-item label="" class="h-elformWrap-2 table-1">
                        <div style="margin-left: 80px;width: 400px;color: #4a4a4a">4.[窜货客户] 被窜客户的名称(该用户的安装信息或发票)</div>
                      </el-form-item>
                      <el-form-item class="h-elformWrap-2" prop="file4">
                        <div style="margin-top: -5px">
                          <brupload
                              :refid="refid"
                              reftype="窜货申诉-信息发票"
                              uploadflag
                              delflag
                              :showtime="false"
                              :tpFlag = 'true'
                          >
                          </brupload>
                        </div>
                      </el-form-item>

                      <el-form-item label="" class="h-elformWrap-2 table-1">
                        <div style="margin-left: 80px;color: #4a4a4a">5.[窜货信息] 其他证明材料</div>
                      </el-form-item>
                      <el-form-item class="h-elformWrap-2" prop="file5">
                        <div style="margin-top: -5px">
                          <brupload
                              :refid="refid"
                              reftype="窜货申诉-其他证明"
                              uploadflag
                              delflag
                              :showtime="false"
                              :tpFlag = 'true'
                          >
                          </brupload>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="anniu" v-if="!resubmit">
              <el-row>
                <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack">返回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
              </el-row>
            </div>
            <div class="anniu" v-else="resubmit">
              <el-row>
                <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack">返回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">重新提交</el-button>
              </el-row>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import agentCopyService from "../../../api/loud/agent/agentCopyService";
import ss from "../../../api/SystemService";
export default {
  data(){
    return {
      appealData:{},
      q:{
      },
      taskid:null,
      instid:null,
      showhistory:false,
      daquflag:false,
      resubmit: false,
      refid: this.$util.getUuid(),
      agentList: {},      //签约经销商
      customerNameList: [],
      rules: {
        channelAppeal: [{required: true, message: '请选择渠道', trigger: 'blur'}],
        customername: [{required: true, message: '请输入窜货方', trigger: 'blur'}],
        userUnit: [{required: true, message: '请输入用户单位', trigger: 'blur'}],
        modelAndNum: [{required: true, message: '请输入型号以数量', trigger: 'blur'}],
        appealContent: [{required: true, message: '请输入申诉事件', trigger: 'blur'}],
      }
    }
  },
  filters: {
  },
  methods: {
    handleFilter(){
      this.querypage();
    },
    choseSelected(){
    },
    pass(aaa){
      let query = {
        taskid:this.$route.query.taskid,
        aaa:aaa,
        auditMind2:this.appealData.auditMind2,
        usercode: this.appealData.usercode,
        instid:this.$route.query.instid,
        validityPeriodDate:this.appealData.validityPeriodDate,
        ywid:this.$route.query.ywid,
        isZhidan: this.appealData.isZhidan
      }
      agentCopyService.agentThawPass(query).then(res => {
        this.$msg.alerts("提交成功！", () => {
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          //跳转回系统的代办列表
          this.$router.push({
            path: '/personal/dealCenter'
          })
        })
      })
    },
    daquPass(aaa){
      let query = {
        taskid:this.$route.query.taskid,
        aaa:aaa,
        auditMind2:this.appealData.auditMind2,
        usercode: this.appealData.usercode,
        instid:this.$route.query.instid,
        validityPeriodDate:this.appealData.validityPeriodDate,
        ywid:this.$route.query.ywid,
      }
      agentCopyService.agentThawDaquPass(query).then(res => {
        this.$msg.alerts("提交成功！", () => {
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          //跳转回系统的代办列表
          this.$router.push({
            path: '/personal/dealCenter'
          })
        })
      })
    },

    viewpress() {
      this.showhistory = true;
    },
    goBack() {
      this.$router.push({
        path: '/orderAppeal'
      })
    },
    //提交
    saveOrSubmit(v){
      this.appealData.isZc = v;
      this.appealData.refid = this.refid;
      console.log(v);
      ss.grabOrderApi.orderAppealAdd(this.appealData).then(res => {
        console.log(res)
        if (res.f) {
          this.$msg.msgs("提交成功！");
          this.$router.push("/orderAppeal");
        } else {
          this.$msg.msge("提交失败！" + res.msg);
        }
      })
    },
    //重新提交
    resaveOrSubmit(){




    },
    showComList(data){
      console.log("data",data);
      if(data == "" ){
            return;
      }
      ss.grabOrderApi.selectByUserNameAppela(data).then(rd=>{
        this.agentList ={},
        console.log("rd",rd)
        if(rd.obj.length > 0){
          this.agentList = rd.obj;
        }else {
          this.agentList = [
            {
              "customerName1" : data,
            }
          ]
          console.log("rd",this.agentList)
        }

      })
    },
    showComList1(value){
      console.log("value",value);
      this.appealData.customercode = value.usercode;
      this.appealData.customername = value.customerName1;
    },
    showGroupList(value) {
      ss.MuBiao.getUserLoud(value).then(res => {
        console.log(res)
        this.customerNameList = res
      })
    },
  },
  created(){
    this.taskid =  this.$route.query.taskid;
    this.instid =  this.$route.query.instid;
    if(this.$route.query.status == 0 || this.$route.query.status == 3){
        this.resubmit = true;
        this.appealData = this.$route.query;
        this.refid = this.$route.query.refid;
    }else {
      this.appealData = {
        username:this._user.username,
        usercode:this._user.usercode,
      };
    }
  },
  computed: {
    UserCode:function () {
      return this.usercode;
    },
  },
  props: {
    dialogVisible: {
      type: Boolean,
    },
  }
}
</script>

<style>
.anniu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
</style>
